import api from "../api";

export const updateContactGat = async (data: any): Promise<any> => {
  const result = await api.put(`/contact`, data);
  if (result.status === 200) {
    return true;
  } else {
    throw new Error("Não foi possível cadastrar Assinantes");
  }
};

export const createContactGat = async (data: any): Promise<any> => {
  const result = await api.post(`/contact`, data);
  if (result.status === 200) {
    return true;
  } else {
    throw new Error("Não foi possível cadastrar Assinantes");
  }
};

export const deleteContactGat = async (id: string): Promise<boolean> => {
  const result = await api.delete(`/contact?Id=${id}`);
  if (result.status === 200) {
    return true;
  } else {
    throw new Error("Não foi possível cadastrar Assinantes");
  }
};

export const getContactsByUserIdGat = async (userId: string, page: number, rowsPerPage: number): Promise<any> => {

  let url = `/contact/get-all-user?`;

  if (userId) {
    url = url + `userId=${userId}`;
  }

  if (page) {
    url = url + `&pageNumber=${page}`;
  }

  if (rowsPerPage) {
    url = url + `&pageSize=${rowsPerPage}`;
  }

  const result = await api.get(url);

  if (result) {
    return result;
  } else {
    throw new Error("Não foi possível cadastrar Assinantes");
  }
};

export const getContactGat = async (id: string): Promise<any> => {
  const result = await api.get(`/contact/?Id=${id}`);
  if (result.status === 200) {
    return result;
  } else {
    throw new Error("Não foi possível cadastrar Assinantes");
  }
};

export const getContactByEmailGat = async (email: string, userId: string): Promise<any> => {
  const result = await api.get(`/contact/get-contact-email?email=${email}&UserId=${userId}`);
  if (result.status === 200) {
    return result;
  } else {
    throw new Error("Não foi possível cadastrar Assinantes");
  }
};

export const getDocumentSignGat = async (documentId: string): Promise<any> => {
  const result = await api.get(`/documents/download?documentId=${documentId}`);
  if (result.status === 200) {
    return result;
  } else {
    throw new Error("Não foi possível pegar o Documento");
  }
};

export const getSignersGat = async (documentId: string): Promise<any> => {
  const result = await api.get(`/users/signers?documentId=${documentId}`);
  if (result.status === 200) {
    return result;
  } else {
    throw new Error("Não foi possível pegar o Documento");
  }
};

export const getSignersEditGat = async (documentId: string): Promise<any> => {
  const result = await api.get(`/users/signers/edit?documentId=${documentId}`);
  if (result.status === 200) {
    return result;
  } else {
    throw new Error("Não foi possível pegar o Documento");
  }
};
